import React, { useState } from "react";
import { formatDate } from "../../../../../Helper_functions";
import SkillsModal from "./SkillsModal";

const JPAInfo = (props) => {
  const [SkillsModalIsOpen, setSkillsModalIsOpen] = useState(false);
  const [LangModalIsOpen, setLangModalIsOpen] = useState(false);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const displayTitle = (Title) => {
    if (Title.length <= 38) {
      return Title;
    } else if (Title !== null) {
      let Shortened = Title.slice(0, 34) + " ...";
      return (
        <React.Fragment>
          {Shortened}
          <p className="popup-text">{Title}</p>
        </React.Fragment>
      );
    }
  };
  const displayChips = (IsSkill, Chips) => {
    var Items = [...Chips];
    var FirstTwo = [];
    if (window.innerWidth <= 550) {
      FirstTwo = [...Items.splice(0, 1)];
    } else {
      FirstTwo = [...Items.splice(0, 2)];
    }
    return (
      <React.Fragment>
        {FirstTwo.map((Chip) => (
          <span className="small-chip">{displayChipText(Chip)}</span>
        ))}
        {IsSkill ? (
          <span
            className="toggle-modal"
            onClick={() => setSkillsModalIsOpen(true)}
          >
            <i className="feather-more-horizontal"></i>
          </span>
        ) : (
          <span
            className="toggle-modal"
            onClick={() => setLangModalIsOpen(true)}
          >
            <i className="feather-more-horizontal"></i>
          </span>
        )}
      </React.Fragment>
    );
  };
  const displayChipText = (ChipText) => {
    if (ChipText.length < 24) {
      return ChipText;
    } else {
      let Shortened = ChipText.slice(0, 20) + " ...";
      return (
        <React.Fragment>
          {Shortened}
          <p className="popup-text">{ChipText}</p>
        </React.Fragment>
      );
    }
  };
  return (
    <div className="info-wrapper">
      {SkillsModalIsOpen ? (
        <SkillsModal
          Close={() => setSkillsModalIsOpen(false)}
          Skills={props.Data.skills}
          Name={props.Data.title}
          PositionTitle={props.Data.workCity}
          IsLang={true}
        />
      ) : null}
      {LangModalIsOpen ? (
        <SkillsModal
          Close={() => setLangModalIsOpen(false)}
          Skills={props.Data.languages}
          Name={props.Data.title}
          PositionTitle={props.Data.workCity}
        />
      ) : null}
      <section className="info-wrapper-head">
        <i className="feather-x" onClick={() => props.Close()}></i>
        {props.Type === "position" ? (
          <h1>{translateText("job_info")}</h1>
        ) : (
          <React.Fragment>
            {props.Type === "project" ? (
              <h1>{translateText("project_info")}</h1>
            ) : (
              <h1>{translateText("activity_info")}</h1>
            )}
          </React.Fragment>
        )}
      </section>
      {props.Data === undefined ? null : (
        <div className="info-main-content ">
          <div className="jpa-main-info">
            <section className="info-head">
              <h1>{displayTitle(props.Data.title)}</h1>
              <span className="head-location">
                <i className="feather-map-pin"></i>
                {props.Data.workCity
                  ? props.Data.workCity
                  : translateText("not_available")}
              </span>
            </section>
            {props.Data.description === null ||
            props.Data.description.length === 0 ? (
              <p className="small-not-available">
                {translateText("description_not_available")}
              </p>
            ) : (
              <p className="jpa-desc">{props.Data.description}</p>
            )}
            <section className="main-info-dates">
              <div className="date-holder">
                <i className="feather-calendar"></i>
                {translateText("start_date")}
                {props.Data.startDate === null ? (
                  <p className="small-not-available">
                    {translateText("not_available")}
                  </p>
                ) : (
                  <p className="date-text">
                    {formatDate(new Date(props.Data.startDate))}
                  </p>
                )}
              </div>
              <div className="date-holder end-date-holder">
                <i className="feather-calendar"></i>
                {translateText("end_date")}
                {props.Data.endDate === null ? (
                  <p className="small-not-available">
                    {translateText("not_available")}
                  </p>
                ) : (
                  <p className="date-text">
                    {formatDate(new Date(props.Data.endDate))}
                  </p>
                )}
              </div>
            </section>
          </div>
          <div className="detailed-info">
            <section className="detailed-info-column column-full">
              <h1 className="info-column-title">
                {translateText("required_profile")}
              </h1>
              <div className="detailed-info-row">
                <span className="row-title">
                  {translateText("top_5_skills")}
                </span>
                <section className="chips-holder">
                  {props.Data.skills === null ||
                  props.Data.skills.length === 0 ? (
                    <p className="small-not-available">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <React.Fragment>
                      {displayChips(true, props.Data.skills)}
                    </React.Fragment>
                  )}
                </section>
              </div>
              <div className="detailed-info-row">
                <span className="row-title">YoE</span>
                <section className="chips-holder">
                  <p>{props.Data.yearsOfExperience}</p>
                </section>
              </div>
              <div className="detailed-info-row">
                <span className="row-title">{translateText("language")}</span>
                <section className="chips-holder">
                  {props.Data.languages === null ||
                  props.Data.languages.length === 0 ? (
                    <p className="small-not-available">
                      {translateText("not_available")}
                    </p>
                  ) : (
                    <React.Fragment>
                      {displayChips(false, props.Data.languages)}
                    </React.Fragment>
                  )}
                </section>
              </div>
              <div className="detailed-info-row">
                <span className="row-title">{translateText("education")}</span>
                <section className="chips-holder">
                  <p>
                    {props.Data.education
                      ? props.Data.education
                      : translateText("not_available")}
                  </p>
                </section>
              </div>
            </section>
          </div>
        </div>
      )}
    </div>
  );
};

export default JPAInfo;
